<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :is-show-store-select="true"
    :has-private-store="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    :show-summary="true"
    :push-list="RouteConfig.invoiceList.push"
    search-placeholder="输入发票对象名称进行搜索"
  >
    <v-column-time value="申请时间"/>
    <v-column-avatar label="申请人员" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="150"
      align="center"
      prop="store_name"
    />
    <el-table-column label="发票对象类型" width="150" align="center">
      <template v-slot="{ row }">{{ row.is_personal ? '个人' : '公司' }}</template>
    </el-table-column>
    <el-table-column label="发票对象名称" width="150" align="center" prop="invoice_name"/>
    <el-table-column label="课卡 ID" width="128" align="center">
      <template v-slot="{ row }">
        <router-link v-if="row.card_id" :to="RouteConfig.cardDetail.to(row.card_id)" class="primary-color">
          No.{{row.card_id}}
        </router-link>
      </template>
    </el-table-column>
    <el-table-column label="开票金额（元）" width="128" align="center" prop="amount" type="money">
      <template v-slot="{ row }">
        {{ row.amount | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="税率（%）" width="128" align="center">
      <template v-slot="{ row }">
        {{ row.tax_rate | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="税额（元）" width="150" align="center" prop="tax_amount" type="money">
      <template v-slot="{ row }">
        {{ row.tax_amount | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="开票进度" width="150" align="center" prop="updateState">
      <template v-slot="{row}">
        <el-tag v-for="state in findInvoiceState(row.state)" :key="state.value" :type="state.tagType">
          {{ state.name }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="150">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="browse" :to="RouteConfig.invoiceDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>申请人员</span>
              <v-avatar-nickname
                :value="v.admin_avatar"
                :nickname="v.admin_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>申请时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div v-if="isAdministrator" class="list-item-detail">
              <span>申请门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>发票对象类型</span>
              <span>{{ v.is_personal ? '个人' : '公司' }}</span>
            </div>
            <div class="list-item-detail">
              <span>发票对象名称</span>
              <span>{{ v.invoice_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡 ID</span>
              <router-link v-if="v.card_id" :to="RouteConfig.cardDetail.to(v.card_id)" class="primary-color">
                No.{{v.card_id}}
              </router-link>
            </div>
            <div class="list-item-detail">
              <span>开票金额（元）</span>
              <span>{{ v.amount | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>税率（%）</span>
              <span>{{ v.tax_rate | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>税额（元）</span>
              <span>{{ v.tax_amount | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>开票进度</span>
              <el-tag v-for="state in findInvoiceState(v.state)" :key="state.value" :type="state.tagType">
                {{ state.name }}
              </el-tag>
            </div>

            <div class="list-item-button">
              <v-list-button name="查看" icon="browse" :to="RouteConfig.invoiceDetail.to(v.id)"/>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>开票金额</span>
              <span class="income-count">{{ amount | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>税额</span>
              <span class="pay-count">{{ taxAmount | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { invoiceStates, findInvoiceState } from '@/enums/invoiceStates';
  import { mapGetters } from 'vuex';
  import { index, destroy } from '@/api/invoice';
  import { getLegalQueryList, pickerOptionsBetweenSystemStartAndToday } from "@/utils/formats";
  import { plus } from '@/filters';

  export default {
    name: RouteConfig.invoiceList.name,
    data: () => ({
      RouteConfig,
      count: 0,
      list: [],
      amount: 0,
      taxAmount: 0,
      queryList: {
        keyword: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
      timeLimit: [],
      isLoading: false,
      isGetting: {},
      isDeleting: {},
      pickerOptionsBetweenSystemStartAndToday,
      invoiceStates,
      findInvoiceState,
    }),
    computed: {
      ...mapGetters([
        'isMobile',
        'isAdministrator',
        'isReceptionist',
      ]),
    },
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      refresh() {
        RouteConfig.invoiceList.push(this.queryList);
      },
      handleStoreChange() {
        this.queryList.page = 1;
        this.refresh();
      },
      handleTimeLimitChange(times) {
        if (!times || !times.length) times = ['', ''];

        this.timeLimit = times;
        const [start_date, end_date] = times;

        Object.assign(this.queryList, {
          start_date,
          end_date,
          page: 1,
        });
        this.refresh();
      },
      handlePageChange({ page, size }) {
        this.queryList.page = page;
        this.queryList.size = size;
        this.refresh();
      },
      async load(route = this.$route, next) {
        const { queryList } = this;
        getLegalQueryList(queryList, route.query);

        this.isLoading = true;
        const { isError, data } = await index(queryList);
        this.isLoading = false;
        if (isError) return;

        this.count = data.count;
        this.list = data.list;

        let amount = 0;
        let taxAmount = 0;

        data.list.forEach(item => {
          amount = plus(amount, item.amount);
          taxAmount = plus(taxAmount, item.tax_amount);
        });

        this.amount = amount;
        this.taxAmount = taxAmount;
        if (next) next();
      },
      async handleDelete(id) {
        if (!id) return this.$message.warning('缺少申请 ID，无法删除该申请！');
        if (this.isDeleting[id]) return;

        this.$set(this.isDeleting, id, true);
        const { isError } = await destroy(id);
        this.$set(this.isDeleting, id, false);
        if (!isError) this.load();
      },
    },
  };
</script>
